import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Consistent bucket name used across the application
export const STORAGE_BUCKET_NAME = 'architect';

/**
 * Get a public URL for a file in Supabase storage
 * @param path The path to the file within the bucket
 * @returns The public URL for the file
 */
export function getStorageUrl(path: string): string {
  // If the path already starts with http, it's already a full URL
  if (path?.startsWith('http')) {
    return path;
  }
  
  // Otherwise, construct the URL using the Supabase URL and bucket name
  return `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/${STORAGE_BUCKET_NAME}/${path || ''}`;
}
